'use client';
import { OrFloorPlanViewer } from '@/components/organisms';
import { EThemes, IMlcopyBlockCSProps } from '@/lib/contentstack-sdk/types';
import { IFloorPlanImage } from '@/lib/search/types';
import { useMemo } from 'react';
import { useLocation } from '@/context/locationContext';
import { useHomePlanData } from './hooks/useHomePlanData';

export const TmHomePlanDetailFloorplansClient = ({
  planId,
  homePlanDetails,
}: {
  planId: number;
  homePlanDetails: { copy_block: IMlcopyBlockCSProps };
}) => {
  const { currentBuildStudio } = useLocation();
  const { planDetailData, defaultFloorplanImages } = useHomePlanData(planId);

  const floorPlans = useMemo(() => {
    const getFloorPlansFromSource = (
      floorPlans?: { FloorPlanImages: IFloorPlanImage[] }[],
    ) =>
      floorPlans?.flatMap(({ FloorPlanImages }) =>
        FloorPlanImages.map((floorPlan) => ({
          title: floorPlan.Type,
          subtitle: undefined,
          image: {
            alt: `${floorPlan.TypeId}_${floorPlan.Type}`,
            priority: false,
            src: {
              mobile: floorPlan.FileName,
              tablet: floorPlan.FileName,
              desktop: floorPlan.FileName,
            },
          },
        })),
      ) ?? [];

    if (currentBuildStudio?.Id) {
      const basePlan = planDetailData.find((plan) => plan.IsBaseElevation);
      return getFloorPlansFromSource(basePlan?.FloorPlans);
    }

    return defaultFloorplanImages?.length
      ? getFloorPlansFromSource([{ FloorPlanImages: defaultFloorplanImages }])
      : [];
  }, [planDetailData, defaultFloorplanImages, currentBuildStudio?.Id]);

  return (
    <>
      {floorPlans && floorPlans?.length > 0 && (
        <OrFloorPlanViewer
          topSpacing="lg"
          bottomDivider
          bottomSpacing="lg"
          heading={{
            ...homePlanDetails?.copy_block,
            heading_element: homePlanDetails?.copy_block?.heading_element,
            heading_variant: homePlanDetails?.copy_block?.heading_variant,
          }}
          description={homePlanDetails?.copy_block?.description}
          blockAlignment={'LEFT'}
          theme={EThemes.LIGHT}
          blueprints={floorPlans}
          floorPlansPDF={null}
        />
      )}
    </>
  );
};
